import React from 'react';
interface SectionProps {
  id?: string;
  title: string;
  children: React.ReactNode;
  tone?: 'cream' | 'deep';
  className?: string;
}
export function Section({
  id,
  title,
  children,
  tone = 'cream',
  className = ''
}: SectionProps) {
  return <section id={id} className={`w-full ${tone === 'deep' ? 'bg-cream-deep' : 'bg-cream'} ${className}`} data-id="element-87" data-mp="3fy84c25few05">
      <div className="mx-auto max-w-5xl px-6 py-20 md:py-28" data-id="element-88" data-mp="3kxb87j9o6w6j">
        <h2 className="font-serif text-4xl leading-[1.05] text-terracotta md:text-5xl" data-id="element-89" data-mp="cg6q9b9d8p1j">{title}</h2>
        <div className="mt-10 md:mt-14" data-id="element-90" data-mp="he87rrr58gaw">{children}</div>
      </div>
    </section>;
}